import React, { useContext, useEffect, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { FaShareAlt } from "react-icons/fa";
import { FaPlayCircle } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import AuthContext from "../context/AuthContext";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "wc-toast";
import { isEmpty } from "lodash";
import obj from "../Utils/helpers";
import SidebarLayout from "../components/shared/SidebarLayout";

const SpinReport = () => {
  const navigate = useNavigate();
  const { profileData, getProfileData, user } = useContext(AuthContext);
  function copy(text) {
    toast.success("Link Copied!");
    return window.navigator.clipboard.writeText(text);
  }
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
  });
  const [matchData, setMatchData] = useState("");
  const getMatchData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.spinReport,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setMatchData(response_users.results);
      }
    }
  };
  useEffect(() => {
    getMatchData();
  }, [search_params]);
  return (
    <>
     <SidebarLayout heading={"Spin Report"}>
      <div class="container main-wrap referral-page p-sm-3 p-2 pt-3">
        
        <div class="content">
          <div class="table-container">
            {/* <ul class="tab-header">
              <li class="">All</li>
              <li class="active">Current</li>
            </ul> */}
            <div class="tab-content">
              <div class="table-container ng-star-inserted">
                <table class="referral-table">
                  <thead>
                    <tr>
                      <th> Spin Count</th>
                      <th> P/L</th>
                      <th> Settle date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {matchData?.data &&
                      matchData?.data?.map((matchList, index) => {
                        return (
                          <tr key={index} style={{ textAlign: `center` }}>
                            <td>{matchList.spin}</td>
                            <td style={{ color: `green` }}>
                              {" "}
                              {matchList.result}
                            </td>

                            <td>
                              {obj.dateFormat(
                                matchList?.createdAt,
                                user?.timeZone
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    {isEmpty(matchData) ? (
                      <tr>
                        <td colSpan={3} class="no-data-message">
                          No records found
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      </SidebarLayout>
    </>
  );
};

export default SpinReport;
